import { cn } from "../lib/cn";

export type Status = "ok" | "warn" | "err" | "neutral" | "running";

const colors: Record<Status, string> = {
  ok: "bg-ok",
  warn: "bg-warn",
  err: "bg-err",
  neutral: "bg-neutral",
  running: "border-2 border-accent border-r-transparent animate-spin bg-transparent",
};

/** 8px status indicator. Always pair with a text label; color never carries meaning alone. */
export function StatusDot({
  status,
  className,
  hollow = false,
}: {
  status: Status;
  className?: string;
  /** A ring instead of a fill: "skipped", "not in this run". */
  hollow?: boolean;
}) {
  return (
    <span
      aria-hidden
      className={cn(
        "inline-block size-2 shrink-0 rounded-full",
        hollow ? "border border-neutral bg-transparent" : colors[status],
        className,
      )}
    />
  );
}
